import { useMemo } from "react";
import { FilterMenu } from "src/components";
import { useGetTeamNetwork } from "src/http";
import { ITeamNetworkObjectFilterOption, TeamNetworkListObjectType } from "./TeamNetworkList";

interface Props {
  teamSlug: string;
  value: TeamNetworkListObjectType | undefined;
  onChange: (value: TeamNetworkListObjectType | undefined) => void;
}

const TeamNetworkListFilterButton = (props: Props) => {
  const { isLoading, data } = useGetTeamNetwork(props.teamSlug);

  const filterOptions = useMemo(() => {
    if (!data) {
      return [];
    }

    const filterOpts: ITeamNetworkObjectFilterOption[] = [];

    if (data.childTeams.length > 0) {
      filterOpts.push({ value: TeamNetworkListObjectType.Team, label: `Teams (${data.childTeams.length})` });
    }

    if (data.roles.length > 0) {
      filterOpts.push({ value: TeamNetworkListObjectType.Role, label: `Roles (${data.roles.length})` });
    }

    if (data.members.length > 0) {
      filterOpts.push({ value: TeamNetworkListObjectType.Member, label: `People (${data.members.length})` });
    }

    return filterOpts;
  }, [data]);

  function handleChange(value: string | undefined) {
    let newValue: TeamNetworkListObjectType | undefined = undefined;

    if (value !== undefined) {
      newValue = Number(value) as TeamNetworkListObjectType;
    }

    props.onChange(newValue);
  }

  return (
    <FilterMenu
      disabled={isLoading || filterOptions.length === 0}
      options={filterOptions.map((x) => ({ label: x.label, value: x.value.toString() }))}
      selectedValue={props.value?.toString()}
      onChange={handleChange}
      hideLabel={true}
      sx={{ mx: { xs: 0.5, sm: 1 }, my: 0.5 }}
    />
  );
};

export { TeamNetworkListFilterButton };
